<div class="compound-field">
  <div class="field">
    @if (label && !isTitle) {
      <label soho-label [attr.for]="id">{{ label }}</label>
    }

    <div [class.hidden]="!isEditing">
      <ng-content>
        <!-- projected lm-field -->
      </ng-content>
    </div>

    <p
      [class.hidden]="isEditing"
      id="{{ id }}"
      attr.data-automation-id="{{ automationId }}"
      class="hide-white-space"
      [ngClass]="isTitle ? 'text-primary' : 'text-default'"
      >
      {{ value }}
    </p>
  </div>
  <div class="field">
    <button
      soho-button="btn"
      type="button"
      class="btn btn-secondary"
      attr.data-automation-id="{{automationId + '-button-' + buttonStateId}}"
      [disabled]="isButtonDisabled"
      (click)="onModeChanged()"
      >
      <span style="font-weight: normal">{{ buttonLabel }}</span>
    </button>
  </div>
</div>
